module.exports = __webpack_public_path__ + "img/Marius van der Wijden.94cc3105.jpg";